import { CollectedItemDetails, MagicCard } from "@apiserver-rest/ponder-data-client-base";
import { FilteredPreviewItem } from "@ponder-shared/tools/filter/filtered-preview-item";
import { FilterType, PreviewItemFilterOption } from "@ponder-shared/tools/filter/preview-item-filter-option";
import { enumFromStringValue } from "@ponder-shared/utils/general";

enum MagicCardOwnership {
    All = "All Cards",
    Collected = "Only Collected",
    Missing = "Only Missing",
    Proxy = "Only Proxy"
};

export class MagicCardFilterOwnership extends PreviewItemFilterOption {
    private currentChoice: MagicCardOwnership = MagicCardOwnership.All;
    private filters = new Map<string, number | undefined>();
    private allValid: boolean = true;

    constructor() {
        super("Ownership", FilterType.Select, "", MagicCardOwnership.All, MagicCardOwnership.All);
    }

    public prepare(): void {
        this.filters.clear();

        Object.values(MagicCardOwnership).forEach(o => {
            if (o == MagicCardOwnership.All) {
                this.filters.set(o, undefined);
            } else {
                this.filters.set(o, 0);
            }
        });
    }

    public track(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): void {
        var key = this.getMatchingOption(collectedInfo);
        this.filters.set(key, this.filters.get(key)! + 1);
    }

    public updateSelection(selection: string, page: string): boolean {
        var ownershipEnum = enumFromStringValue(MagicCardOwnership, selection);

        if (!ownershipEnum || (this.currentChoice == ownershipEnum)) {
            return false;
        }

        this.setStoredFilter(selection, page);
        this.currentChoice = ownershipEnum;
        this.allValid = (ownershipEnum == MagicCardOwnership.All);
        this.wasUpdated = true;
        
        return true;
    }

    public getFilters(): Map<string, number | undefined> {
        return this.filters;
    }

    public isValid(magicCard: MagicCard, collectedInfo: CollectedItemDetails | undefined): boolean {
        return this.allValid || (this.currentChoice == this.getMatchingOption(collectedInfo));
    }

    private getMatchingOption(collectedInfo: CollectedItemDetails | undefined): MagicCardOwnership {
        if (collectedInfo?.count || collectedInfo?.specialCount) {
            return MagicCardOwnership.Collected;
        } else if (collectedInfo?.proxyCount) {
            return MagicCardOwnership.Proxy
        } else {
            return MagicCardOwnership.Missing;
        }
    }

    public sort(previewItems: FilteredPreviewItem[]): void {
        // ... nothing ...
    }

    public override setUserInfo(isCollection: boolean, isAuthed: boolean): void {
        // ... nothing ...
    }
}